import { Select } from "antd";
import React, { useEffect } from "react";
import { LineChartGeneral } from "../../../components/Graphics/LineChartGeneral";
import ProjectCardItem from "../../../components/Card/ProjectCardItem";
import { CardTable } from "../../../components/Card/CardTable";
import useSemaforo from "./hooks/useSemaforo";
import { elipses } from "../new-project/indexAssets";
import useYear from "../../../hooks/Year";

export const PageGraphSemaforo = () => {
    const { listOfYears, updateYear, year } = useYear(5);
    const { projectsList, updateSemaforo, status, statusProjectList, updateProjectStatus } = useSemaforo();

    useEffect(() => {
        updateSemaforo(year);
    }, [updateSemaforo, year]);

    return (
        <section className="w-full h-[calc(100vh-64px)] p-4 ">
            <div className="w-full h-full ">
                <CardTable title={"Gráfica por estado"} currentValue={year} listValues={listOfYears} updateValue={updateYear}>
                    <div className="w-full h-full flex flex-col  ">
                        <div className=" w-full h-fit flex flex-wrap px-12 justify-center gap-5 ">
                            <ProjectCardItem elipseImage={elipses.elipseGreen} value={status.verde} label="0%-69%" typeOfData="Satisfactorio" />
                            <ProjectCardItem elipseImage={elipses.elipseYellow} value={status.amarillo} label="70%-100%" typeOfData="Ideal" />
                            <ProjectCardItem elipseImage={elipses.elipseOrange} value={status.super_rojo} label="101%-115%" typeOfData="Excedido" />
                            <ProjectCardItem elipseImage={elipses.elipseRed} value={status.rojo} label=">115%" typeOfData="Peligro" />
                            <ProjectCardItem elipseImage={elipses.elipsePurple} value={status.morado} label=">200%" typeOfData="Desbordado" />
                        </div>
                        <div className="w-full grow flex flex-wrap justify-center  pt-10  ">
                            <div className="w-1/2 pt-6 ">
                                <p className="text-xs font-bold leading-normal mb-[48px]">Gráfica general</p>
                                <div className="w-[294px] md:w-[442px] h-[252px] md:h-[380px] lg:w-4/5 lg:h-[480px]  bg-[#f5f5f5]">
                                    <LineChartGeneral datas={projectsList} />
                                </div>
                            </div>
                            <div className="w-1/2 pt-6  ">
                                <p className="text-xs font-bold leading-normal">Gráfica por estado</p>
                                <div className="w-full flex justify-end mb-4">
                                    <Select
                                        onChange={(value) => updateProjectStatus(value)}
                                        defaultActiveFirstOption={"TODOS"}
                                        defaultValue={"TODOS"}
                                        className="w-[130px] ml-auto"
                                    >
                                        <Select.Option value="ACTIVO">ACTIVO</Select.Option>
                                        <Select.Option value="PAUSA">PAUSA</Select.Option>
                                        <Select.Option value="CONCLUIDO">CONCLUIDO</Select.Option>
                                        <Select.Option value="CANCELADO">CANCELADO</Select.Option>
                                        <Select.Option value="TODOS">TODOS</Select.Option>
                                    </Select>
                                </div>
                                <div className="w-[294px] md:w-[442px] h-[252px] md:h-[380px] lg:w-4/5 lg:h-[480px]  bg-[#f5f5f5] flex justify-center">
                                    <LineChartGeneral datas={statusProjectList} />
                                </div>
                            </div>
                        </div>
                    </div>
                </CardTable>
            </div>
        </section>
    );
};
